/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-07-27 17:25:33
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/plan/pumping_page";

// /*根据计划id获取人员分派列表*/
export function assign_list(params) {
  return request({
    url: "/icps/system/sign/basics/plan/assign/assign_list",
    method: "get",
    params,
  });
}
// /*根据内外部的区分获取泵自编号等信息*/
export function assignpump_list(params) {
  return request({
    url: "/icps/system/sign/basics/plan/assign/pumpListBycompanyId",
    method: "get",
    params,
  });
}
/*根据车辆类型获取车辆列表*/
export function assigncat_list(params) {
  return request({
    url: "/icps/system/sign/basics/plan/assign/cat_list",
    method: "get",
    params,
  });
}
/*根据角色id获取用户列表*/
export function useruser_list(params) {
  return request({
    url: "/base/system/role/user/user_list",
    method: "get",
    params,
  });
}
/*根据角色id获取用户列表*/
export function save_or_update(data) {
  return request({
    url: "/icps/system/sign/basics/plan/assign/save_or_update",
    method: "post",
    data,
  });
}
/**
 * @Description: 批量分派
 * @param {*} data
 * @Author: wangwangwang
 */
export function batchDispatch(data) {
  return request({
    url: "/icps/system/sign/basics/plan/assign/save_or_update_new",
    method: "post",
    data,
  });
}
/*查看泵送难度*/
export function queryPumpingDifficultyRecord(data) {
  return request({
    url: "/icps/system/sign/basics/plan/queryPumpingDifficultyRecord",
    method: "post",
    data,
  });
}

/*计算泵送难度*/
export function calculatePumpingDifficultyRecord(data) {
  return request({
    url: "/icps/system/sign/basics/plan/calculatePumpingDifficultyRecord",
    method: "post",
    data,
  });
}

/*保存泵送难度*/
export function savePumpingDifficultyRecord(data) {
  return request({
    url: "/icps/system/sign/basics/plan/savePumpingDifficultyRecord",
    method: "post",
    data,
  });
}

/*保存泵送难度*/
export function queryPageDetails(data) {
  return request({
    url: "/icps/system/sign/intelligent/codeDischarge/queryPageDetails",
    method: "post",
    data,
  });
}
/*恢复取消任务*/
export function cancelAssignPlan(data) {
  return request({
    url: "/icps/system/sign/basics/plan/assign/cancelAssignPlan",
    method: "post",
    data,
  });
}
